import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=68ea1082&"
import script from "./Scroll.vue?vue&type=script&lang=js&"
export * from "./Scroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports